import React from "react";
import {CCard} from "@coreui/react";
import {FaInfoCircle} from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import "./ScatterPlotContainer.css";
import { useTranslation } from "react-i18next";

const ScatterPlotContainer = ({children}) => {
    const { t } = useTranslation();
    return (
        <CCard className="background-ccard-scatterPlot">
            <div className="div-row-container">
                <Tooltip
                    title={<span className="tooltip-window">{t("legend_tooltip_message")}</span>}
                    arrow
                >
                    <IconButton>
                        <FaInfoCircle className="info-icon"/>
                    </IconButton>
                </Tooltip>
            </div>
            {children}
        </CCard>
    );
};

export default ScatterPlotContainer;
